import { Container, IDestroyOptions, Texture, Ticker } from "pixi.js";
import { Emitter, EmitterConfigV2, upgradeConfig } from "@pixi/particle-emitter";

export class ConfetyParticleAnimationView extends Container {
    private readonly emitter: Emitter;
    private readonly particlesLifetimeMs: number;

    private animationTimeMs: number;
    public isActive: boolean;

    public constructor(config: EmitterConfigV2, textures: Array<Texture>) {
        super();
        const configV3 = upgradeConfig(config, textures);
        const alphaBehaviors = configV3.behaviors.find(item => item.type === "alpha");
        alphaBehaviors.config = {
            "alpha": {
                "list": [
                    {
                        "time": 0,
                        "value": 1

                    },
                    {
                        "time": 0.85,
                        "value": 1,
                    },
                    {
                        "time": 1,
                        "value": 0
                    }
                ]
            }
        }
        const moveSpeedBehaviors = configV3.behaviors.find(item => item.type === "moveSpeed");
        moveSpeedBehaviors.config = {
            "speed": {
                "list": [
                    {
                        "time": 0,
                        "value": 8000
                    },
                    {
                        "time": 0.09,
                        "value": 500
                    },
                    {
                        "time": 0.4,
                        "value": 100
                    },
                    {
                        "time": 1,
                        "value": 50
                    }
                ]
            },
            "minMult": 0.05
        }
        configV3.lifetime.min = 1.5;
        configV3.lifetime.max = 2;
        this.emitter = new Emitter(this, upgradeConfig(configV3, textures));
        this.animationTimeMs = 0;
    }

    public async play(): Promise<void> {
        this.emitter.autoUpdate = true;
        Ticker.shared.add(this.updateTime, this);
        this.isActive = true;
    }

    public setProgress(progress: number): void {
        this.animationTimeMs = this.particlesLifetimeMs * progress;
    }

    private updateTime(): void {
        this.animationTimeMs += Ticker.shared.elapsedMS;
        if (this.animationTimeMs >= this.particlesLifetimeMs) {
            this.emitter.autoUpdate = false;
            Ticker.shared.remove(this.updateTime, this);
            this.isActive = false;
            this.animationTimeMs = 0;
        }
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.emitter.autoUpdate = false;
        Ticker.shared.remove(this.updateTime, this);
        super.destroy(options);
    }
}
